module.exports = __webpack_public_path__ + "img/Kugel_Geschichten.7eaa514c.svg";